export default "__VITE_ASSET__ByyesC3x__"